export default __webpack_public_path__ + "static/media/secret_service.27e31d51.jpeg";